import { OpaqueUrl } from '../../../common/routing/util';
import { FilterPreset } from '../../page-seo/types';

export type LinkSpec = { url: OpaqueUrl; title: string };

export const makeSpecialtyPreset = (practitionerTerm: string, title?: string): FilterPreset => ({
  title,
  filters: { topic: { specialist: practitionerTerm } },
});

export const makeProcedurePreset = (treatment: string, title?: string): FilterPreset => ({
  title,
  filters: { topic: { treatment } },
});

export const makeInterestPreset = (treatment: string, title?: string): FilterPreset => ({
  filters: { topic: { treatment } },
  title,
});
